import { types, Actions } from './actions';
import { CustomerMasterStateType } from './index';
import {
  keyOptionsMap, KEY_TYPE, OPERATOR_TYPE, SEARCH_TYPE,
} from '../../pages/customer/advancedSearch/options';

const initialState: CustomerMasterStateType = {
  customerList: [],
  isListFromAdvancedSearch: false,
  conditionRequests: [{
    key: KEY_TYPE.CUSTOMER_NUMBER,
    operator: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfOperatorType || OPERATOR_TYPE.EQUAL,
    value: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfValueType || '',
  }],
  conditionType: SEARCH_TYPE.AND,
  conditionName: '',
};

const reducer = (state = initialState, actions: Actions): CustomerMasterStateType => {
  const newState = { ...state };
  switch (actions.type) {
    case types.SET_CUSTOMER_LIST:
      newState.customerList = actions.payload.list;
      newState.isListFromAdvancedSearch = actions.payload.isListFromAdvancedSearch;
      return newState;

    case types.SAVE_ADVANCED_SEARCH_SETTINGS:
      newState.conditionRequests = actions.payload.conditionRequests;
      newState.conditionName = actions.payload.conditionName;
      newState.conditionType = actions.payload.conditionType;
      return newState;

    default:
      return state;
  }
};

export default reducer;
